import { TeaserEntry } from '../helper/interfaces'
import ChevronRight from '../public/icons/chevron-right.svg'
import React from 'react'
import Link from "next/link";
import { getLinkObjectFromTeaser } from '../helper/link'

interface Data {
  teasers: TeaserEntry[],
  navigate: (articleId: string, ressortId: string) => void,
}

function BreakingNewsRessortComponent(data: Data) {

  const teasers = data.teasers

  return (
    <React.Fragment>
      { teasers.length > 0 && 
        <div className="breakingnews linkbox">
            { teasers.map((teaser) => {
              const linkObject = getLinkObjectFromTeaser(teaser);
            return (
              <React.Fragment key={`breakingNews-${teaser.id}`}>
                <div className="linkbox__url mb-2">
                  { linkObject && linkObject.internalLink && (
                    <Link href={linkObject.internalLink}>
                      <ChevronRight />
                      { teaser.topline &&
                        <>
                          <span className="topline">{teaser.topline}</span>
                          <span className="">{teaser.title}</span>
                        </>
                      }
                      { !teaser.topline &&
                        <span className="topline">{teaser.title}</span>
                      }
                    </Link>
                  )}
                  { linkObject && linkObject.externalLink && (
                    <Link href={linkObject.externalLink} target="_blank"  rel="noreferrer">
                      <ChevronRight />
                      { teaser.topline &&
                        <>
                          <span className="topline">{teaser.topline}</span>
                          <span className="">{teaser.title}</span>
                        </>
                        
                      }
                      { !teaser.topline &&
                        <span className="topline">{teaser.title}</span>
                      }
                    </Link>
                  )}
                </div>
              </React.Fragment>
            )
          })
          }
        <div className="fading"></div>
      </div>
    }
    </React.Fragment>
  )
}

export default BreakingNewsRessortComponent